(function(){
  function checkCartForBogo(){
    fetch('/cart?section_id=cart_widget', {headers: {'Accept': 'text/html'}, cache: 'no-store'})
      .then(function(r){ return r.text(); })
      .then(function(html){
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var freshEl = doc.getElementById('nt_gift_progress');
        var currentEl = document.getElementById('nt_gift_progress');
        if (freshEl && currentEl) {
          currentEl.outerHTML = freshEl.outerHTML;
        }
      })
      .catch(function(){});
  }

  var CART_URL_RE = /\/cart\/(add|change|update|clear)/;

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function(){
      var args = arguments;
      var url = args[0];
      var urlStr = (typeof url === 'string') ? url : (url && url.url) || '';
      var p = origFetch.apply(this, args);
      if (CART_URL_RE.test(urlStr)) {
        p.then(function(res){ setTimeout(checkCartForBogo, 150); return res; })
         .catch(function(err){ setTimeout(checkCartForBogo, 150); throw err; });
      }
      return p;
    };
  }

  try {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url){
      this.__nt_cart_url = url;
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function(){
      var xhr = this;
      if (xhr.__nt_cart_url && CART_URL_RE.test(xhr.__nt_cart_url)) {
        xhr.addEventListener('loadend', function(){ setTimeout(checkCartForBogo, 150); });
      }
      return origSend.apply(this, arguments);
    };
  } catch(e) {}

  document.addEventListener('DOMContentLoaded', checkCartForBogo);
  if (document.readyState !== 'loading') { checkCartForBogo(); }
})();
